import { defineStore } from 'pinia';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';

interface iBottomMenuItem {
  title: string;
  position: number;
}

export const useStoreBottomMenu = defineStore('bottomMenu', {
  state: () => ({
    itemCentralTitle: '' as string,
    itemMenu: {} as iBottomMenuItem,
    itemLobby: {} as iBottomMenuItem,
    itemSearch: {} as iBottomMenuItem,
    itemSupport: {} as iBottomMenuItem,
    requestPromise: null as Promise<any> | null,
  }),
  actions: {
    async loadBottomMenu() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'itemMenu',
          'itemLobby',
          'itemSearch',
          'itemSupport',
        ]);

        this.requestPromise = strapi()
          .get('bottom-menu', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
